import {
  type Json,
  type SduiItem,
  SduiItemsRenderer
} from './SduiItemsRenderer';

interface ReportsFieldsPanelProps {
  currentPageTitle: string;
  errorMessage?: string;
  isLoading: boolean;
  items: SduiItem[];
  onChange: (path: string, value: Json) => void;
}

const ReportsFieldsPanel = ({
  currentPageTitle,
  errorMessage,
  isLoading,
  items,
  onChange
}: ReportsFieldsPanelProps) => {
  return (
    <div className="bg-muted/10 flex h-full min-w-0 flex-col">
      <div className="min-h-0 flex-1 overflow-x-hidden overflow-y-auto p-3">
        {isLoading ? (
          <div className="text-muted-foreground text-sm">Loading fields...</div>
        ) : errorMessage ? (
          <div className="text-muted-foreground text-sm">
            Failed to load fields: {errorMessage}
          </div>
        ) : (
          <SduiItemsRenderer
            currentPageTitle={currentPageTitle}
            items={items}
            onChange={onChange}
          />
        )}
      </div>
    </div>
  );
};

export default ReportsFieldsPanel;
